<div class="container">
  <div #captchaRef></div>
</div>
